import { Capacitor } from "@capacitor/core";

import { environmentConfig } from "./config";

/**
 * Returns the base URL of the admin web app.
 *
 * On native Capacitor platforms, returns the configured app domain from
 * environmentConfig so it matches the backend's BASE_URL allowlist, rather
 * than the dev server's LAN IP from window.location.
 *
 * Mirrors cbh-mobile-app's getAppUrl() pattern.
 */
export function getAppUrl(): string {
  if (Capacitor.isNativePlatform()) {
    return environmentConfig.REACT_APP_ADMIN_APP_CLIENT_URL;
  }

  const { hostname, pathname, origin } = window.location;

  // Handle CloudFront PR preview environments (e.g. /pr-123/...)
  if (hostname.endsWith("cloudfront.net")) {
    const match = /^\/pr-\d+\//.exec(pathname);
    if (match) {
      return `${origin}${match[0].slice(0, -1)}`;
    }
  }

  return origin;
}
